__turbopack_context__.v({
  "container": "styles-module-scss-module__HX1rva__container",
  "imageRight": "styles-module-scss-module__HX1rva__imageRight",
  "textContent": "styles-module-scss-module__HX1rva__textContent",
});
